import React from 'react';
import IconUser from '../../images/common/icon_user.png';
import IconUser2x from '../../images/common/icon_user@2x.png';
import IconFacebook from '../../images/register/icon_facebook.png';
import IconFacebook2x from '../../images/register/icon_facebook@2x.png';

const Sns = () => {
  return (
    <section>
      <h2 className="curve_title">
        <img
          src={ IconUser }
          srcSet={ `${ IconUser } 1x, ${ IconUser2x } 2x` }
          alt="ソーシャルアカウントでログイン"
        />
        ソーシャルアカウントで登録
      </h2>
      <ul className="sns_login">
        <li>
          <a href="/oauth/facebook">
            <img
              src={ IconFacebook }
              srcSet={ `${ IconFacebook } 1x, ${ IconFacebook2x } 2x` }
              alt="Facebookでログイン"
            />
            <span>Facebookでログイン</span>
          </a>
        </li>
      </ul>
    </section>
  );
}

export default Sns;
